import { render, staticRenderFns } from "./renwu-list.vue?vue&type=template&id=748ae146&scoped=true&"
import script from "./renwu-list.vue?vue&type=script&lang=ts&"
export * from "./renwu-list.vue?vue&type=script&lang=ts&"
import style0 from "./renwu-list.vue?vue&type=style&index=0&id=748ae146&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748ae146",
  null
  
)

export default component.exports